export const ADD_IMAGE = 'ADD_IMAGE';
export const GET_THEME = 'GET_THEME';
export const SET_ARRAY = 'SET_ARRAY';
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const GET_DEVICE = 'GET_DEVICE';
export const API_UPLOAD = 'API_UPLOAD';
export const MAP_IMAGES = 'MAP_IMAGES';
export const SET_RENDER = 'SET_RENDER';
export const GET_SESSION = 'GET_SESSION';
export const RETAKE_ARRAY = 'RETAKE_ARRAY';
export const COLLECT_IMAGE = 'COLLECT_IMAGE';
export const RESET_SESSION = 'RESET_SESSION';
export const CHECK_SESSION = 'CHECK_SESSION';
export const LOADING_ANIMATE = 'LOADING_ANIMATE';
export const SAVE_SESSION_KEY = 'SAVE_SESSION_KEY';
export const DECLARE_DATA_FLOW = 'DECLARE_DATA_FLOW';
export const CHECKING_REPORT_DAMAGES = 'CHECKING_REPORT_DAMAGES';
export const SET_SESSION_STATUS = 'SET_SESSION_STATUS';
export const SET_INVALID_WARNING = 'SET_INVALID_WARNING';
export const CLEAR_INVALID_WARNING = 'CLEAR_INVALID_WARNING';